/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var PureRenderMixin, React, ReactDOM, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

css = require('../css/login.styl');

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  getDefaultProps: function() {},
  displayName: 'Login',
  componentDidMount: function() {
    return this.refs.nickname.focus();
  },
  handleSubmit: function(ev) {
    var nickname;
    ev.preventDefault();
    nickname = this.refs['nickname'].value.trim();
    if (!(nickname.length > 2)) {
      return;
    }
    return this.props.actions.loginUser(nickname);
  },
  dismissError: function() {
    this.props.actions.dismissError();
  },
  renderError: function() {
    var error;
    if (!(error = this.props.user.error)) {
      return null;
    }
    return React.createElement("div", {
      "className": "alert alert-info alert-dismissible",
      "role": "alert"
    }, React.createElement("button", {
      "type": "button",
      "className": "close",
      "onClick": this.dismissError,
      "aria-label": "Close"
    }, React.createElement("span", {
      "aria-hidden": "true"
    }, "×")), React.createElement("strong", null, "Chybička!"), " ", this.props.user.error);
  },
  render: function() {
    return React.createElement("div", {
      "className": css['login']
    }, React.createElement("form", {
      "onSubmit": this.handleSubmit,
      "className": css['form'] + ' form-horizontal'
    }, React.createElement("div", {
      "className": css['heading']
    }, "VSTOUPIT DO HRY"), this.renderError(), React.createElement("div", {
      "className": "form-group"
    }, React.createElement("div", {
      "className": "col-sm-12"
    }, React.createElement("input", {
      "className": css['input'] + ' form-control',
      "id": "nickname",
      "name": "nickname",
      "ref": "nickname",
      "placeholder": "Přezdívka",
      "tabIndex": "1"
    }))), React.createElement("div", {
      "className": "form-group"
    }, React.createElement("div", {
      "className": "col-sm-12"
    }, React.createElement("button", {
      "type": "submit",
      "className": css['button'] + ' btn btn-lg btn-primary'
    }, "\t\t\t\t\t\t\tVstoupit")))));
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "login.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/login.cjsx
 ** module id = 257
 ** module chunks = 0
 **/